// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ArrowUpRightFromSquare as RawArrowUpRightFromSquare } from "lucide-react";
export const ArrowUpRightFromSquare = /* @__PURE__ */ createIcon(RawArrowUpRightFromSquare, "ArrowUpRightFromSquare", 2);
